"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBraintreeGooglePayClientChecked = exports.getBraintreeGooglePayClient = exports.setBraintreeGooglePayClient = exports.getBraintreeGooglePayInstanceChecked = exports.getBraintreeGooglePayInstance = exports.setBraintreeGooglePayInstance = exports.getBraintreeApplePaySessionChecked = exports.getBraintreeApplePaySession = exports.setBraintreeApplePaySession = exports.getBraintreeApplePayInstanceChecked = exports.getBraintreeApplePayInstance = exports.setBraintreeApplePayInstance = exports.hasBraintreeClient = exports.getBraintreeClient = exports.setBraintreeClient = exports.getBraintreeAppleCredentialsChecked = exports.getBraintreeAppleCredentials = exports.setBraintreeAppleCredentials = exports.getBraintreeGoogleCredentialsChecked = exports.getBraintreeGoogleCredentials = exports.setBraintreeGoogleCredentials = void 0;
const src_1 = require("..");
function setBraintreeGoogleCredentials(credentials) {
    src_1.braintreeState.googleCredentials = credentials;
}
exports.setBraintreeGoogleCredentials = setBraintreeGoogleCredentials;
function getBraintreeGoogleCredentials() {
    return src_1.braintreeState.googleCredentials;
}
exports.getBraintreeGoogleCredentials = getBraintreeGoogleCredentials;
function getBraintreeGoogleCredentialsChecked() {
    if (!src_1.braintreeState.googleCredentials) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: googleCredentials is null');
    }
    return src_1.braintreeState.googleCredentials;
}
exports.getBraintreeGoogleCredentialsChecked = getBraintreeGoogleCredentialsChecked;
function setBraintreeAppleCredentials(credentials) {
    src_1.braintreeState.appleCredentials = credentials;
}
exports.setBraintreeAppleCredentials = setBraintreeAppleCredentials;
function getBraintreeAppleCredentials() {
    return src_1.braintreeState.appleCredentials;
}
exports.getBraintreeAppleCredentials = getBraintreeAppleCredentials;
function getBraintreeAppleCredentialsChecked() {
    if (!src_1.braintreeState.appleCredentials) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: appleCredentials is null');
    }
    return src_1.braintreeState.appleCredentials;
}
exports.getBraintreeAppleCredentialsChecked = getBraintreeAppleCredentialsChecked;
function setBraintreeClient(braintree) {
    src_1.braintreeState.braintree = braintree;
}
exports.setBraintreeClient = setBraintreeClient;
function getBraintreeClient() {
    return src_1.braintreeState.braintree;
}
exports.getBraintreeClient = getBraintreeClient;
function hasBraintreeClient() {
    return !!src_1.braintreeState.braintree;
}
exports.hasBraintreeClient = hasBraintreeClient;
function setBraintreeApplePayInstance(applePayInstance) {
    src_1.braintreeState.appleInstance = applePayInstance;
}
exports.setBraintreeApplePayInstance = setBraintreeApplePayInstance;
function getBraintreeApplePayInstance() {
    return src_1.braintreeState.appleInstance;
}
exports.getBraintreeApplePayInstance = getBraintreeApplePayInstance;
function getBraintreeApplePayInstanceChecked() {
    if (!src_1.braintreeState.appleInstance) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: appleInstance is null');
    }
    return src_1.braintreeState.appleInstance;
}
exports.getBraintreeApplePayInstanceChecked = getBraintreeApplePayInstanceChecked;
function setBraintreeApplePaySession(applePaySession) {
    src_1.braintreeState.appleSession = applePaySession;
}
exports.setBraintreeApplePaySession = setBraintreeApplePaySession;
function getBraintreeApplePaySession() {
    return src_1.braintreeState.appleSession;
}
exports.getBraintreeApplePaySession = getBraintreeApplePaySession;
function getBraintreeApplePaySessionChecked() {
    if (!src_1.braintreeState.appleSession) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: appleSession is null');
    }
    return src_1.braintreeState.appleSession;
}
exports.getBraintreeApplePaySessionChecked = getBraintreeApplePaySessionChecked;
function setBraintreeGooglePayInstance(googlePayInstance) {
    src_1.braintreeState.googlePayInstance = googlePayInstance;
}
exports.setBraintreeGooglePayInstance = setBraintreeGooglePayInstance;
function getBraintreeGooglePayInstance() {
    return src_1.braintreeState.googlePayInstance;
}
exports.getBraintreeGooglePayInstance = getBraintreeGooglePayInstance;
function getBraintreeGooglePayInstanceChecked() {
    if (!src_1.braintreeState.googlePayInstance) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: googlePayInstance is null');
    }
    return src_1.braintreeState.googlePayInstance;
}
exports.getBraintreeGooglePayInstanceChecked = getBraintreeGooglePayInstanceChecked;
function setBraintreeGooglePayClient(googlePayClient) {
    src_1.braintreeState.googlePayClient = googlePayClient;
}
exports.setBraintreeGooglePayClient = setBraintreeGooglePayClient;
function getBraintreeGooglePayClient() {
    return src_1.braintreeState.googlePayClient;
}
exports.getBraintreeGooglePayClient = getBraintreeGooglePayClient;
function getBraintreeGooglePayClientChecked() {
    if (!src_1.braintreeState.googlePayClient) {
        throw new src_1.BraintreeNullStateKeyError('Precondition violated: googlePayClient is null');
    }
    return src_1.braintreeState.googlePayClient;
}
exports.getBraintreeGooglePayClientChecked = getBraintreeGooglePayClientChecked;
